module.exports = __webpack_public_path__ + "static/media/trending.71d32fce.svg";


//////////////////
// WEBPACK FOOTER
// ./src/style/SVGs/trending.svg
// module id = 185
// module chunks = 0